import { Icons } from '@app/models/Icon/Icon.model';
import { FetchIconsSuccessAction, FETCH_ICONS_SUCCESS } from './types';

export function fetchIconsSuccess(icons: Icons): FetchIconsSuccessAction {
  return {
    type: FETCH_ICONS_SUCCESS,
    icons,
  };
}
